// extracted by mini-css-extract-plugin
module.exports = {"subscribe-form":"Form_subscribe-form__BPVh4"};